module.exports = __webpack_public_path__ + "media/images/Image_collection-054f8dc2c95cd14b2245c5f4315938ce.png";